import { Component, OnInit } from '@angular/core';
import { TabName } from '../../../models/_enum-collections';
import { PreviewDocumentTypes } from '../../../models/update-customer-ack-document.model';
import { SpecialInvestmentTableComponent } from '../../shared/special-investment-table/special-investment-table.component';

@Component({
  selector: 'app-findings-document',
  templateUrl: './findings-document.component.html',
  styleUrls: ['./findings-document.component.scss'],
  standalone: true,
  imports: [SpecialInvestmentTableComponent]
})
export class FindingsDocumentComponent implements OnInit {
  tabName!: number;
  prevDocumentType!: string;
  isPoeDoc = true;

  ngOnInit() {
    this.tabName = TabName.FindingDocReview;
    this.prevDocumentType = PreviewDocumentTypes.poedocument;
  }
}
